<script>
import Header from "./Header.vue";

export default {
  components: {
    Header
  }
}
</script>

<template>
  <div>
    <!--get all scores-->
    <img alt="MLB logo" src="../assets/mlb.png">
    <Header v-on:date-changed="dateChange" heading="MLB Regular Season Scores (2016-2019)"/>
    <h1>{{date}}</h1>
    <h1 v-if="loading">{{loadingMessage}}</h1>
    <h1 v-if="noGames">No Games Found</h1>
    <div class="flex">
      <div :key="score" v-for="score in scores">
        <GameScore
          :teamOne="score.teamOne"
          :teamTwo="score.teamTwo"
          :teamOneScore="score.teamOneScore"
          :teamTwoScore="score.teamTwoScore"
        />
      </div>
    </div>
  </div>
</template>

<script>
import GameScore from "./GameScore.vue";
import axios from "axios";
import Header from './Header.vue'

export default {
  name: "Scores",
  scores: [],
  loading: false,
  noGames: true,
  loadingMessage: "Loading",
  props: {
    date: {
      type: String,
      default: "2019-08-30"
    }
  },
  components: {
    GameScore,
    Header
  },
  data() {
    return {
      scores: []
    };
  },
  watch: {
    date() {
      this.getScores();
    }, 
    loadingMessage() {
      return this.loadingMessage;
    },
    loading() {
      return this.loading;
    }
  },
  mounted() {
    this.getScores();
  },
  methods: {
    appendToLoadingMessage() {
      var self = this;
      setTimeout(function() {
        if (self.loading) {
          self.appendToLoadingMessage();
        }
      }, 500);
    },
    dateChange(date) {
      this.date = date;
    },
    getScores() {
      var self = this;
      var apiDate = this.date.replace(/-/g, "");
      var year = this.date.substring(0, 4);
      var getString =
        "https://api.mysportsfeeds.com/v2.1/pull/mlb/" +
        year +
        "-regular/date/" +
        apiDate +
        "/games.json";
      self.scores = [];
      self.loading = true;
      self.appendToLoadingMessage();
      axios
        .get(getString, {
          auth: {
            username: "a577c455-3e68-457f-908c-4ffb07",
            password: "MYSPORTSFEEDS"
          }
        })
        .then(function(response) {
          console.log(response.data);
          if (response.data.games.length == 0) {
            self.noGames = true;
          } else {
            self.noGames = false;
          }
          for (var score of response.data.games) {
            self.scores.push({
              teamOne: score.schedule.awayTeam.abbreviation,
              teamOneScore: score.score.awayScoreTotal,
              teamTwo: score.schedule.homeTeam.abbreviation,
              teamTwoScore: score.score.homeScoreTotal
            });
          }
          self.loading = false;
          self.loadingMessage = "Loading Scores...";
        });
    },
    getLoadingMessage() {
      return this.loadingMessage;
    }
  }
};
</script>

<style scoped>
.flex {
  flex-wrap: wrap;
  display: flex;
  justify-content: center;
}

img {
  width: 20vw;
}
</style>
